import React from 'react';
import axios from 'axios';
import { useSearchParams } from 'react-router-dom';
import { motion } from 'framer-motion';

import CardOfCase from '../CardOfCase';
import HeaderPanel from '../HeaderPanel';
import InfoBlock from '../InfoBlock';

import { formatDate, formatComment, formatNull, getCaseStyle, formatOverflow } from '../../Utils/GlobalUtils';
import { useModal } from '../Modal/ModalContext';

import LoadingLines from '../LoadingLines';
import Loading from '../Loading';

import headerPanel from '../../styles/HeaderPanel.module.css';

const AMTable = () => {
    const { openModal } = useModal();
    const [searchParams, setSearchParams] = useSearchParams();

    const [limitForView, setLimitForView] = React.useState(10);
    const [cases, setCases] = React.useState([]);
    const [warning, setWarning] = React.useState('');

    const [reload, setReload] = React.useState(true);
    const [loading, setLoading] = React.useState(true);
    const [miniLoading, setMiniLoading] = React.useState(false);
    
    const [visibilityBtn, setVisibilityBtn] = React.useState(false);

    const [lastUpdateTime, setLastUpdateTime] = React.useState('--:--');

    React.useEffect(() => {
        setMiniLoading(true);
        const token = localStorage.getItem('token');
        axios.get(`/api/cases-for-AM?limitForView=${limitForView}`, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        })
        .then(response => {
            if (response.data.length === 0) {
                setCases([]);
                setWarning('Таблица пуста. Сейчас вы не назначены ни на одно дело. Проверьте страницу "Заявки".');
                setVisibilityBtn(false);
            } else {
                setWarning('');
                setCases(response.data);
                setVisibilityBtn(response.data.length >= limitForView);
            }

            const currentTime = new Date();
            const formattedTime = currentTime
                .toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit' });
            setLastUpdateTime(formattedTime);
        })
        .catch((error) => {
            console.error(error);
            setWarning(`Ошибка при загрузке таблицы дел:  ${error.response?.data.message || error.message}`);
        })
        .finally(() => {
            setLoading(false);
            setReload(false);
            setMiniLoading(false);
        });
    }, [reload]);

    const colorsDescriptionModal = 
    <form>
        <div style={{display: 'flex', alignItems: 'center', padding: '10px', borderRadius: '.5em', boxSizing: 'border-box', border: '1px solid rgb(56, 0, 0)', backgroundColor: 'rgb(255, 240, 240)', marginBottom: '5px'}}>
            <a style={{margin: '0'}}>Судебное заседание прошло, но в карточке отсутствует дата назначения арбитражного управляющего.</a>
        </div>
        <div style={{display: 'flex', alignItems: 'center', padding: '10px', borderRadius: '.5em', boxSizing: 'border-box', border: '1px solid blue', backgroundColor: 'rgb(235, 245, 255)', marginBottom: '5px'}}>
            <a style={{margin: '0'}}>Карточка не заполнена, отсутствует сформированная конечная дата.</a>
        </div>
        <div style={{display: 'flex', alignItems: 'center', padding: '10px', borderRadius: '.5em', boxSizing: 'border-box', border: '1px solid rgb(255, 14, 14)', backgroundColor: 'rgb(255, 247, 247)'}}>
            <a style={{margin: '0'}}>Исполнение этапа не проведено в срок.</a>
        </div>
    </form>;

    const [idCaseForModal, setIdCaseForModal] = React.useState('');
    const [isCardOfCaseModal, setIsCardOfCaseModal] = React.useState(false);

    return (
        <>
            {isCardOfCaseModal && <CardOfCase closeModal={() => {setIsCardOfCaseModal(false); setSearchParams({});}} id={idCaseForModal} onCardOfCaseSuccess={() => {setReload(true)}} />}
            <div className='mainContainer'>
            <InfoBlock />
            <HeaderPanel typePanel='Арбитражный управляющий' />
            <div style={{display: 'flex', justifyContent: 'space-between', marginTop: '5px'}}>
                <div onClick={() => {openModal('Обозначения цветов таблицы', colorsDescriptionModal)}} style={{marginRight: '12px'}} className='textButton'>Обозначения</div>
                <a style={{display: 'flex', alignItems: 'center'}}>Последнее обновление таблицы: {lastUpdateTime} {miniLoading && <Loading widthParam='mini' />}</a>
            </div>
            <motion.div
                initial={{ scale: '97%', opacity: 0 }}
                animate={{ scale: '100%', opacity: 1 }}
                exit={{ scale: '97%', opacity: 0 }}
                transition={{ duration: 0.3 }}
            >
                <div className='tableContainer'>
                    <div className='tableHeader'>
                        <a className='numberCase'>Номер</a>
                        <a className='categoryCase'>Категория</a>
                        <a className='applicantCase'>Должник и регион</a>
                        <a className='dateSendCandidateCase'>Дата отправки кандидатуры</a>
                        <a className='dateCourtCase'>Дата судебного заседания</a>
                        <a className='dateAMAppointmentCase'>Дата назначения</a>
                        <a className='datesCase'>Начальная дата / Конечная дата текущего этапа</a>
                        <a className='statusCase'>Статус</a>
                    </div>
                    {loading ? <LoadingLines /> 
                    : warning ? <div className='case warningLine'><a>{warning}</a></div>
                    : cases.map((caseItem) => (
                        <div className='case' key={caseItem.id} style={getCaseStyle(caseItem.date_end, caseItem.date_court, caseItem.date_am_appointment, caseItem.status)} onClick={() => {setIsCardOfCaseModal(true); setIdCaseForModal(caseItem.id); setSearchParams({ case: caseItem.id })}}>
                            <a className='numberCase'>{formatNull(caseItem.number)} <span style={{color: 'rgb(169, 169, 169)'}}>{caseItem.internal_number}</span></a>
                            <a className='categoryCase'>{caseItem.status=="В работе" ? formatNull(formatOverflow(caseItem.phaseName)) : (<>Дело завершено</>)}</a>
                            <a className='applicantCase'>{formatNull(caseItem.applicant)} {formatNull(caseItem.region)}</a>
                            <a className='dateCourtCase'>{formatDate(caseItem.date_court)}</a>
                            <a className='dateSendCandidateCase'>{formatDate(caseItem.date_am_appointment)}</a>
                            <a className='dateAMAppointmentCase'>{formatDate(caseItem.date_am_appointment)}</a>
                            <a className='datesCase'>{formatDate(caseItem.date_start)} / {formatDate(caseItem.date_end)}</a>
                            <a className='statusCase' style={{borderBottom: 'none', borderRight: 'none'}}>{caseItem.status}</a>
                        </div>
                    ))}
                    {visibilityBtn && <span style={{display: 'flex', justifyContent: 'center'}}><button type='button' className='button' onClick={() => {setLimitForView(prev => prev + 10); setReload(true)}}>Загрузить ещё</button></span>}
                </div>
            </motion.div>
        </div>
        </>
    )
}

export default AMTable;